import React from "react";

export default function Commoninstruction(props) {
  return (
    <>
     {/* Render the section for common instructions */}
      <section className="col-sm-6 col-12">
        <div className="box-steps-instruction">
          {/* Render individual steps */}
          {props.step[0].map((step, index) => (
            <div key={index} className={index === 0 && "fw-bold"}>
              {step}
            </div>
          ))}

          {/* Display a general instruction */}
          <div>
            Steps as per Vedic maths to solve this problem is as follows
          </div>

          {/* Render detailed steps */}
          {props.step[1].map((step, index) =>
            step.map((value, index) => (
              <div className={index === 0 ? "fw-bold" : "mx-3"} key={index}>
                {value}
              </div>
            ))
          )}
        </div>
      </section>
    </>
  );
}
